import React from "react";
import cn from "helpers/classnames";

const testimonials = [
  {
    name: "Maria S.",
    role: "High School Teacher",
    text: "This is a fantastic resource! It will also save hours of prep time!"
  },
  {
    name: "Kara B.",
    role: "Middle School Teacher",
    text: "This has been an essential resource for me. I’ve already recommended LitCharts to colleagues!"
  }
];

const TestimonialSection = () => (
  <div
    className={cn(
      "tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-py-[30px] tw-px-[15px] md:tw-py-10"
    )}
  >
    <div>
      <h5 className="title-5 tw-text-center tw-text-teal tw-my-0">
        Trusted by 400+ Schools and Institutions
      </h5>
    </div>
    <div
      className={cn(
        "tw-flex tw-gap-4 tw-bg-white tw-pt-3 tw-rounded-lg tw-max-w-[710px] tw-w-full",
        "tw-flex-col tw-justify-center md:tw-flex-row md:tw-px-0 md:tw-gap-5 md:tw-max-w-[932px]"
      )}
    >
      {testimonials.map((t) => (
        <div key={t.name} className="tw-flex tw-items-start tw-flex-1">
          <i className="lc-icon lc-icon-quote-filled tw-text-blue lc-icon-md tw-mr-2" />
          <div className="tw-pt-1">
            <div className="body-3 tw-font-bold">
              {t.name}{" "}
              <span className="tw-font-semibold tw-text-teal">{t.role}</span>
            </div>
            <div className="body-1">{t.text}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default TestimonialSection;
